import { Price, Product } from '../types/Add-subscription.types';
import { getAvailableAddons } from '../utils/Add-subscription.util';
import AddonGroup from './AddonGroup';

interface AvailableAddonsProps {
  products: Product[];
  period: 'Mensual' | 'Anual';
  counts: Record<number, number>;
  selectedAddons: Record<number, boolean>;
  handleAddonToggle: (priceId: number) => void;
  getAdvantages: (product: Product, price: Price) => { name: string }[];
}

const AvailableAddons = ({
  getAdvantages,
  products,
  period,
  counts,
  selectedAddons,
  handleAddonToggle,
}: AvailableAddonsProps) => {
  const availableAddons = getAvailableAddons({ products, period, counts });

  if (availableAddons.length === 0) return null;

  return (
    <AddonGroup
      getAdvantages={getAdvantages}
      period={period}
      products={products}
      counts={counts}
      addons={availableAddons}
      selectedAddons={selectedAddons}
      onToggle={handleAddonToggle}
    />
  );
};

export default AvailableAddons;
